<template>
	<div class="link-handler">
		<a :href="url" target="_blank" @click.prevent="handleLink">{{ title }}</a>
		<transition name="fade">
			<PopupWarning
				class="fast-fade fade-enter-active"
				v-if="showPopup"
				:externalUrl="url"
				@close="closePopup"
			/>
		</transition>
	</div>
</template>

<script>
import { mapState } from "vuex";
import PopupWarning from "@/components/base/PopupWarning";

export default {
	name: 'SidebarInfoPopup',
	components: {
		PopupWarning,
	},
	props: {
		title: {
			type: String,
			required: true,
		},
		url: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			showPopup: false,
		};
	},
	computed: {
		...mapState({
			isBrainPop: (state) => state.global.api.data.config.brain_pop,
		}),
	},
	methods: {
		handleLink() {
			if (this.isBrainPop) {
				this.showPopup = true;
			} else {
				window.open(this.url, '_blank');
			}
		},
		closePopup() {
			this.showPopup = false;
		},
	},
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/base/LinkHandler.vue